/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuideResource } from "./GuideResource";
export const GuideDetailResponse = core.serialization.object({
    data: GuideResource,
});
